import clsx from "clsx";
import { set } from "date-fns";
import { useState, useEffect, useMemo } from "react";
export default function TimePick({
  curDateTime,
  onChange,
  minuteInterval = 5,
}: {
  curDateTime: Date;
  onChange: (date: Date) => void;
  minuteInterval?: number;
}) {
  const hours = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  const minutes = useMemo(() => {
    if (minuteInterval <= 0 || minuteInterval > 59) {
      throw new Error(
        "Interval must be a positive number greater than 0 and less than or equal to 59.",
      );
    }

    const result = [];
    for (let i = 0; i <= 59; i += minuteInterval) {
      result.push(i);
    }

    return result;
  }, [minuteInterval]);

  const iniHour =
    curDateTime.getHours() > 12
      ? curDateTime.getHours() - 12
      : curDateTime.getHours();

  const [firstHourIndex, setFirstHourIndex] = useState(
    iniHour > 7 ? iniHour - 7 : 0,
  );

  const iniMinuteIndex = minutes.findIndex(
    (m) => m == Math.min(curDateTime.getMinutes(), minutes?.length - 7),
  );
  const [firstMinuteIndex, setFirstMinuteHour] = useState(
    iniMinuteIndex >= 0 ? iniMinuteIndex : 0,
  );

  const [selectedHour, setSelectedHour] = useState(iniHour);
  const [selectedMinute, setSelectedMinute] = useState(
    curDateTime.getMinutes(),
  );
  const [selectedAmPm, setSelectedAmPm] = useState(
    curDateTime.getHours() < 12 ? 0 : 1,
  );

  useEffect(() => {
    const newHour = selectedHour == 12 ? 0 : selectedHour;
    const d = set(new Date(curDateTime), {
      hours: newHour + (selectedAmPm == 1 ? 12 : 0),
      minutes: selectedMinute,
    });
    onChange(
      set(new Date(curDateTime), {
        hours: newHour + (selectedAmPm == 1 ? 12 : 0),
        minutes: selectedMinute,
        seconds: 0,
      }),
    );
  }, [selectedHour, selectedMinute, selectedAmPm]);
  return (
    <div
      className={
        "flex w-[176px] h-[352px] max-h-[352px] p-2 bg-white rounded-2xl shadow-xl text-base"
      }
    >
      <div
        className="flex-grow max-h-full overflow-hidden"
        onWheel={(e) => {
          const direction = e.deltaY > 0 ? "down" : "up";
          if (direction == "up") {
            if (firstHourIndex > 0) {
              setFirstHourIndex(Math.max(firstHourIndex - 1, 0));
            }
          }
          if (direction == "down") {
            if (firstHourIndex < hours.length - 7) {
              setFirstHourIndex(Math.min(firstHourIndex + 1, hours.length - 7));
            }
          }
        }}
      >
        {hours.slice(firstHourIndex, firstHourIndex + 7).map((hour) => {
          return (
            <div
              key={hour}
              className={clsx(
                "h-10 w-12 rounded-xl flex items-center justify-center my-2 cursor-pointer",
                selectedHour == hour
                  ? "bg-blue-500 text-white"
                  : "hover:bg-gray-100",
              )}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setSelectedHour(hour);
              }}
            >
              {hour}
            </div>
          );
        })}
      </div>
      <div
        className="flex-grow max-h-full overflow-hidden"
        onWheel={(e) => {
          const direction = e.deltaY > 0 ? "down" : "up";
          if (direction == "up") {
            if (firstMinuteIndex > 0) {
              setFirstMinuteHour(Math.max(firstMinuteIndex - 1, 0));
            }
          }
          if (direction == "down") {
            if (firstMinuteIndex < minutes.length - 7) {
              setFirstMinuteHour(
                Math.min(firstMinuteIndex + 1, minutes.length - 7),
              );
            }
          }
        }}
      >
        {minutes.slice(firstMinuteIndex, firstMinuteIndex + 7).map((minute) => {
          return (
            <div
              key={minute}
              className={clsx(
                "h-10 w-12 rounded-xl flex items-center justify-center my-2 cursor-pointer",
                selectedMinute == minute
                  ? "bg-blue-500 text-white"
                  : "hover:bg-gray-100",
              )}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setSelectedMinute(minute);
              }}
            >
              {minute}
            </div>
          );
        })}
      </div>
      <div className="flex-grow">
        <div
          className={clsx(
            "h-10 w-12 rounded-xl flex items-center justify-center my-2 cursor-pointer",
            selectedAmPm == 0 ? "bg-blue-500 text-white" : "hover:bg-gray-100",
          )}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setSelectedAmPm(0);
          }}
        >
          AM
        </div>
        <div
          className={clsx(
            "h-10 w-12 rounded-xl flex items-center justify-center my-2 cursor-pointer",
            selectedAmPm == 1 ? "bg-blue-500 text-white" : "hover:bg-gray-100",
          )}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setSelectedAmPm(1);
          }}
        >
          PM
        </div>
      </div>
    </div>
  );
}
